export let isPrivacyMode = false;

export const setGlobalPrivacyMode = (mode) => {
  isPrivacyMode = mode;
};

export const formatMoney = (val) => {
  if (isPrivacyMode) return '******';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};

export const formatMoneyDetail = (val) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};

export const formatMoney4 = (val) => {
  if (isPrivacyMode) return '******';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(val);
};

export const formatNumber4 = (val) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(val);
};

export const formatNumber = (val) => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 7,
  }).format(val);
};

export const formatPercent = (val) => {
  return `${val > 0 ? '+' : ''}${val.toFixed(2)}%`;
};

// Converts YYYY-MM-DD to DD/MM/YYYY
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = String(dateStr).split('-');
  if (parts.length === 3) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return dateStr;
};
